"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  commonWebAnalytics: true
};
Object.defineProperty(exports, "commonWebAnalytics", {
  enumerable: true,
  get: function get() {
    return _commonWebAnalytics["default"];
  }
});
var _backgroundFilterWebAnalytics = require("./backgroundFilterWebAnalytics");
Object.keys(_backgroundFilterWebAnalytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _backgroundFilterWebAnalytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _backgroundFilterWebAnalytics[key];
    }
  });
});
var _commonWebAnalytics = _interopRequireDefault(require("./commonWebAnalytics"));